import { FileDownloadOutlined, FileUploadOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Input,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import config from "../../../config/config";

const ReplicacaoArte = ({
  handleFileChange,
  fileName,
  uploading,
  onPreviousStep,
  onNextStep,
  question,
  gabarito,
  fileQuestionButton,
  briefingFinalizado,
  nameInput,
  steps,
  hasManual,
  setHasManual,
  finalSteps,
  previousSteps,
  referencia,
  setFormData,
  setHasArt,
  replicableArts,
}) => {
  const [artesParaReplicar, setArtesParaReplicar] = useState([]);
  const [selectedArt, setSelectedArt] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalConfirmacao, setModalConfirmacao] = useState(false);

  const toggleModal = () => {
    setModalConfirmacao(!modalConfirmacao);
  }

  const getArtsForReplicant = () => {
    setArtesParaReplicar(replicableArts)
  };

  useEffect(() => {
    getArtsForReplicant();
  }, [replicableArts]);

  const getBriefingUrl = (briefing) =>
    briefing?.briefing_obj?.art_final_url || briefing?.art_final_url;

  const isBriefingBlocked = (briefing) => briefing?.replicavel === false;

  const getDownloadUrl = (briefing) =>
    briefing?.download_url || getBriefingUrl(briefing);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {artesParaReplicar?.length > 0 ? (
        <>
          <h1 style={{ textAlign: "center" }}>{question}</h1>
          {artesParaReplicar.map((arte, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection="column"
              alignItems="center"
              mb={1}
              width="100%"
            >
              {arte.briefings &&
                arte.briefings.map((briefing, index) => (
                  <Box
                    key={index}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    mb={1}
                    width="100%"
                  >
                    <Card sx={{ width: "100%", maxWidth: 600 }}>
                      <CardActionArea
                        component="div"
                        onClick={(e) => {
                          if (isBriefingBlocked(briefing)) return;

                          setSelectedArt(
                            getBriefingUrl(briefing)
                          );
                          setFormData((prevState) => ({
                                                        ...prevState,
                                                        ["Arte Pronta"]: {
                                                          art_final_url: getBriefingUrl(briefing),
                                                          arte_id: briefing.arte_id,
                                                        },
                                                      }));
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            height: "0",
                            paddingBottom: "68%", // Mantém a proporção quadrada
                            position: "relative",
                          }}
                        >
                          <iframe
                            title={briefing.product_name}
                            src={getBriefingUrl(briefing)?.replace("dl=0", "raw=1")}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              border: "none",
                            }}
                          ></iframe>
                        </Box>
                        <CardContent>
                          <Typography gutterBottom variant="h6">
                            {briefing.product_name}
                          </Typography>
                          {isBriefingBlocked(briefing) ? (
                            <Box display="flex" flexDirection="column" gap={1}>
                              <Typography color="error" fontWeight="bold">
                                Esta arte não pode ser replicada.
                              </Typography>
                              {briefing.mensagem_bloqueio && (
                                <Typography>
                                  {briefing.mensagem_bloqueio}
                                </Typography>
                              )}
                              {getDownloadUrl(briefing) && (
                                <Button
                                  component="a"
                                  href={getDownloadUrl(briefing)}
                                  target="_blank"
                                  rel="noreferrer"
                                  variant="outlined"
                                  startIcon={<FileDownloadOutlined />}
                                  sx={{ alignSelf: "flex-start", mt: 1 }}
                                >
                                  {briefing.download_label || "Baixar arte aprovada anteriormente"}
                                </Button>
                              )}
                            </Box>
                          ) : (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  value={getBriefingUrl(briefing)}
                                  onClick={(e) => {
                                    setSelectedArt(
                                      getBriefingUrl(briefing)
                                    );
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      ["Arte Pronta"]: {
                                        art_final_url: getBriefingUrl(briefing),
                                        arte_id: briefing.arte_id,
                                      },
                                    }));
                                  }}
                                  checked={
                                    selectedArt === getBriefingUrl(briefing)
                                  }
                                />
                              }
                              label="Selecionar"
                            />
                          )}
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Box>
                ))}
            </Box>
          ))}

          <Box display="flex" justifyContent="center" margin="10px">
            <Button
              variant="contained"
              type="button"
              onClick={() => onPreviousStep(previousSteps ? previousSteps : 1)}
              color="secondary"
            >
              Anterior
            </Button>
            <Box width="20px" />
            <Button
              variant="contained"
              type="button"
              color="success"
              onClick={() => {
                let realSteps = steps;
                realSteps = 14;
                onNextStep(14);
                // toggleModal(); // Descomente essa linha para ativar o modal de confirmação
              }}
              disabled={!selectedArt}
            >
              Próximo
            </Button>

            {briefingFinalizado && !gabarito && (
              <Box display="flex">
                <Box width="20px" />
                <Button
                  variant="contained"
                  disabled={!selectedArt}
                  color="info"
                  onClick={() => onNextStep(finalSteps)}
                >
                  Finalizar
                </Button>
              </Box>
            )}
          </Box>
        </>
      ) : (
        <Box>
          {!loading && (
            <h1>
              Parece que você não tem artes disponíveis para replicar, favor
              preencher o briefing normal.
            </h1>
          )}
        </Box>
      )}
      {loading && (
        <Box mt={5}>
          <Typography>
            Buscando artes disponíveis ...
            <CircularProgress size={20}></CircularProgress>
          </Typography>
        </Box>
      )}
      {artesParaReplicar == null && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginBottom={5}
        >
          <Box height="20px" />
          <Box display="flex" justifyContent="center" margin="10px">
            <Button
              variant="contained"
              type="button"
              onClick={() => onPreviousStep(previousSteps ? previousSteps : 1)}
              color="secondary"
            >
              Anterior
            </Button>
            <Box width="20px" />
            <Button
              variant="contained"
              type="submit"
              color="success"
              onClick={() => {
                setHasArt(false);
                onNextStep(0);
              }}
            >
              Próximo
            </Button>

            {briefingFinalizado && !gabarito && (
              <Box display="flex">
                <Box width="20px" />
                <Button
                  variant="contained"
                  disabled={!fileName || referencia === ""}
                  color="info"
                  onClick={() => onNextStep(finalSteps)}
                >
                  Finalizar
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      )}
      <Modal open={modalConfirmacao} onClose={toggleModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box style={
          {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: {
              xs: "80%",
              sm: "70%",
              md: "60%",
              lg: "40%",
              xl: "40%"
            },
            background: 'linear-gradient(to top left, white, #83a802)',
            border: '1px solid #000',
            borderRadius: 8,
            boxShadow: 24,
            p: 4,
            padding:"20px"
          }
        }>
          <Box display="flex" flexDirection="column" justifyContent="center" margin="10px" textAlign="center">
            <Typography style={{fontWeight: "bold", color:"red", fontSize:"20px"}}>INFORMAÇÃO IMPORTANTE PARA CLIENTE RECORRENTE</Typography>
            <Box width="20px" />
            <Typography>
              Prezado cliente, passamos por uma atualização em nosso sistema, no <span style={{fontWeight:"bold"}}>gerenciamento de cores</span>, os arquivos que forem replicados(clientes recorrentes) <span style={{fontWeight:"bold"}}>poderão sofrer alteração na cor do produto final</span>, sugerimos que façam o preenchimento de briefing novamente, para que aprovem uma nova prova e possam confirmar a cor do material que irá para produção.
            </Typography>

          </Box>
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="center"  // Centraliza os itens horizontalmente
            justifyContent="center"  // Centraliza os itens verticalmente
            textAlign="center"
            mt={1}
          >
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                localStorage.removeItem('formData');
                localStorage.removeItem('formState');
                localStorage.removeItem('produto');
                localStorage.removeItem('step');
                window.location.reload();
              }}
              style={{ width: "80%" }}
            >
              Sim, desejo preencher novamente
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={()=> {
                onNextStep(14)
              }}
              style={{ width: "80%", marginTop: "10px" }}  // Adiciona um espaçamento entre os botões
            >
              Não, desejo continuar com a arte selecionada
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ReplicacaoArte;
